import { Renderer2 } from '@angular/core';

export class BaseGenerator {
  tag: string;
  type: string;
  location?: HTMLElement;

  private script: any;

  constructor(tag: string, type: string) {
    this.tag = tag;
    this.type = type;
  }

  setTag(renderer2: Renderer2, data: object, location: HTMLElement): void {
    this.location = location;

    this.removeTag(renderer2, location);

    this.script = renderer2.createElement(this.tag);
    this.script.type = this.type;
    this.script.text = `${JSON.stringify(data)}`;

    renderer2.appendChild(this.location, this.script);
  }

  removeTag(renderer2: Renderer2, _location: HTMLElement): void {
    if (typeof this.script !== 'undefined') {
      renderer2.removeChild(this.location, this.script);
    }
  }
}
